import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Tooltip } from '../Tooltip';
import { LabelWithHint } from './LabelWithHint';
import { BaseDisplay } from './styled';
export const Display = forwardRef(({ level, hint, tooltip, tone, weight, elementType, children, ...rest }, ref) => {
    let childrenUI = children;
    if (tooltip) {
        const tooltipProps = typeof tooltip === 'string'
            ? { title: tooltip, placement: 'top' }
            : tooltip;
        childrenUI = (_jsx(Tooltip, { ...tooltipProps, children: _jsx("span", { children: childrenUI }) }));
    }
    else if (hint) {
        childrenUI = _jsx(LabelWithHint, { hint: hint, children: children });
    }
    return (_jsx(BaseDisplay, { ...rest, tone: tone, weight: weight, as: elementType, level: level, ref: ref, children: childrenUI }));
});
